var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2754",
    "data-name": "Group 2754",
    transform: "translate(0.44 -0.28)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_195",
    "data-name": "Ellipse 195",
    cx: 18,
    cy: 17.5,
    rx: 18,
    ry: 17.5,
    transform: "translate(-0.44 0.28)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2750",
    "data-name": "Group 2750",
    transform: "translate(10.774 10.423)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_693",
    "data-name": "Line 693",
    y2: 14.147,
    transform: "translate(7.074)",
    fill: "none",
    stroke: "#040f1f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_694",
    "data-name": "Line 694",
    y2: 14.147,
    transform: "translate(14.147 7.074) rotate(90)",
    fill: "none",
    stroke: "#040f1f",
    strokeWidth: 2
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.7dcd873651599becf3d8dff828deb2d0.svg";
export { ForwardRef as ReactComponent };